// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__Nqkzl","errorLogs":"styles_errorLogs__3LjiS"};